module.exports = __webpack_public_path__ + "static/champions-of-coaching-44db35969041d8d294b1f53a9ad0146b.jpg";